import {
	Typography,
	Box,
	MenuItem,
	Select,
	TextField,
	Button,
	useTheme,
} from '@mui/material';
import { connect } from 'react-redux';
import ModalDialog from '../ModalDialog/ModalDialog';
import { useNavigate } from 'react-router-dom';
import React, { useCallback, useMemo, useState } from 'react';
import { useResolutionScale } from '../../hooks';
import ScanOrEnterBarcodeForm from '../ScanOrEnterBarcodeForm/ScanOrEnterBarcodeForm';

const mapStateToProps = (state) => ({
	themeMode: state.theme.themeMode,
	partValidation: state,
});

const ReasonAndRemarkModal = ({
	partValidation,
	themeMode,
	open,
	handleClose,
	nameofModal,
	handleSubmit,
	leftTitle,
	rightTitle,
	dropDown,
	reasonLabel,
	data,
	setSecondApiStop,
}) => {
	// console.log(data, "data")
	const { scaleValue } = useResolutionScale();
	const [reason, setReason] = useState(dropDown?.[0] || '');
	const [remarks, setRemarks] = useState('');
	const isDark = themeMode === 'dark';
	const colors = useMemo(
		() => ({
			bgOuter: isDark ? '#2B2B2B' : '#F2F2F2',
			label: isDark ? '#E0E0E0' : '#202020',
			value: isDark ? '#FFFFFF' : '#202020',
			inputBg: isDark ? '#3A3A3A' : '#F8F8F8',
			border: isDark ? '#a7a7a7ff' : '#231F20',
			selectColor: isDark ? '#EAEAEA' : '#231F20',
			buttonGradient: 'linear-gradient(90deg, #231F20 0%, #000000 100%)',
			buttonText: '#FFFFFF',
		}),
		[isDark],
	);

	const onConfirm = useCallback(() => {


		handleSubmit(reason, remarks);
	}, [reason, remarks, handleSubmit]);
	if (!open) return null;

	return (
		<ModalDialog open={open} title={nameofModal} onClose={handleClose}>
			<Box
				sx={{
					width: '60%',
					display: 'flex',
					flexDirection: 'column',
					gap: scaleValue(1),
					boxSizing: 'border-box',
				}}
			>
				{/* VIN + KSPEC Section */}
				<Box sx={{ display: 'flex', flex: 1, gap: scaleValue(4) }}>
					<Box sx={{ flex: 1 }}>
						<Typography
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 400,
								fontSize: `${scaleValue(20)}px`,
								color: colors.label,
							}}
						>
							{leftTitle}
						</Typography>
						<Typography
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 600,
								fontSize: `${scaleValue(20)}px`,
								color: colors.value,
							}}
						>
							{data?.vin || data?.partName || 'N/A'}
						</Typography>
					</Box>

					<Box sx={{ flex: 1 }}>
						<Typography
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 600,
								fontSize: `${scaleValue(20)}px`,
								color: colors.label,
							}}
						>
							{rightTitle}
						</Typography>
						<Typography
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 600,
								fontSize: `${scaleValue(20)}px`,
								color: colors.value,
							}}
						>
							{data?.KSPEC || data?.partNumber || data?.partName || 'N/A'}
						</Typography>
					</Box>
				</Box>

				{/* Reason & Remarks Section */}
				<Box sx={{ display: 'flex', gap: scaleValue(4) }}>
					<Box sx={{ flex: 1 }}>
						<Typography
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 400,
								fontSize: `${scaleValue(20)}px`,
								color: colors.label,
								mb: 1,
							}}
						>
							{reasonLabel || (leftTitle === 'VIN' ? 'Reason' : 'Reason to take out the part')}
						</Typography>

						<Select
							fullWidth
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							sx={{
								height: scaleValue(46),
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 600,
								fontSize: `${scaleValue(20)}px`,
								background: colors.inputBg,
								border: `1px solid ${colors.border}`,
								borderRadius: `${scaleValue(8)}px`,
								color: colors.selectColor,
								'& .MuiSelect-icon': {
									color: colors.selectColor,
								},
							}}
						>
							{dropDown?.map((item, index) => (
								<MenuItem key={index} value={item}>
									{item}
								</MenuItem>
							))}
						</Select>
					</Box>

					<Box sx={{ flex: 1 }}>
						<Typography
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 400,
								fontSize: `${scaleValue(20)}px`,
								color: colors.label,
								mb: 1,
							}}
						>
							Remarks
						</Typography>
						<TextField
							fullWidth
							multiline
							minRows={5}
							maxRows={10}
							value={remarks}
							onChange={(e) => {
								const value = e.target.value;
								const filteredValue = value.replace(/[^a-zA-Z0-9 \n]/g, '').toUpperCase();
								setRemarks(filteredValue);
							}}
							placeholder="Please enter"
							sx={{
								fontFamily: 'JLR Emeric, sans-serif',
								fontWeight: 600,
								fontSize: `${scaleValue(20)}px`,
								background: colors.inputBg,
								border: `1px solid ${colors.border}`,
								borderRadius: `${scaleValue(8)}px`,
								'& .MuiInputBase-input': {
									color: colors.selectColor,
									overflowY: 'auto',
									maxHeight: scaleValue(160),
									scrollbarWidth: 'thin',
									'&::-webkit-scrollbar': {
										width: '6px',
									},
									'&::-webkit-scrollbar-thumb': {
										backgroundColor: '#888',
										borderRadius: '4px',
									},
								},
							}}
						/>
					</Box>
				</Box>

				{/* Buttons */}
				<Box
					sx={{
						display: 'flex',
						gap: scaleValue(4),
						justifyContent: 'center',
						mt: scaleValue(3),
					}}
				>
					<Button
						variant="outlined"
						onClick={handleClose}
						sx={{
							width: scaleValue(200),
							height: scaleValue(40),
							borderRadius: `${scaleValue(16)}px`,
							textTransform: 'none',
							fontFamily: 'JLR Emeric, sans-serif',
							fontWeight: 600,
							fontSize: `${scaleValue(24)}px`,
							color: colors.label,
							borderColor: colors.border,
							'&:hover': {
								backgroundColor: isDark ? '#3A3A3A' : '#E5E5E5',
							},
						}}
					>
						Cancel
					</Button>

					<Button
						variant="contained"
						disableElevation
						disabled={!reason || !remarks.trim()}
						sx={{
							width: scaleValue(200),
							height: scaleValue(40),
							borderRadius: `${scaleValue(16)}px`,
							textTransform: 'none',
							fontFamily: 'JLR Emeric, sans-serif',
							fontWeight: 600,
							fontSize: `${scaleValue(24)}px`,
							background: colors.buttonGradient,
							color: colors.buttonText,
							'&:hover': {
								opacity: 0.9,
								background: colors.buttonGradient,
							},
						}}
						onClick={onConfirm}
					>
						Confirm
					</Button>
				</Box>
			</Box>
		</ModalDialog>
	);
};

export default connect(mapStateToProps)(React.memo(ReasonAndRemarkModal));
